import { Link } from "react-router-dom";
import classnames from "classnames";
import { Utils } from "helpers/utils";
import { useRedux } from "hooks";
import { createSelector } from "reselect";
import { changeSelectedContentTitle } from "../../../redux/actions";
import LoadingIconWithText from "components/LoadingIconWithText";
import { useRef, useEffect } from "react";
import "./ContentUploadSlip.css";
import ContentUploadSlipCore from "./ContentUploadSlipCore";

export type { SlipRecord } from "./ContentUploadSlipCore";

const storeDataSelector = createSelector(
  (state: any) => state.Chats,
  (state: any) => state.Profile2,
  (chats, profile) => ({
    selectedContentTitle: chats.selectedContentTitle,
    selectedContentTitleMode: chats.selectedContentTitleMode,
    selectedContentTitleLoading: chats.selectedContentTitleLoading,
    contentTitles: chats.contentTitles ?? [],
    contentTitleInfo: chats.contentTitleInfo ?? {},
    custContents: chats.custContents,
    selectedContentTitleKey: chats.selectedContentTitleKey,
    activeGroupId: profile.activeGroupId,
  })
);

const ContentUploadSlip = () => {
  const { dispatch, useAppSelector } = useRedux();
  const {
    selectedContentTitle, selectedContentTitleMode, selectedContentTitleLoading,
    custContents, activeGroupId,
  } = useAppSelector(storeDataSelector);

  const activeGroupIdRef = useRef(activeGroupId);
  useEffect(() => { activeGroupIdRef.current = activeGroupId; }, [activeGroupId]);

  const getContentTitle = () => {
    for (let i = 0; i < custContents.length; ++i) {
      for (let j = 0; j < custContents[i].contentTitles.length; ++j) {
        if (custContents[i].contentTitles[j].contentTitleId === selectedContentTitle) {
          return custContents[i].contentTitles[j];
        }
      }
    }
    return null;
  };

  const contentTitleSel = getContentTitle();
  const isDark = Utils.IsDarkTheme();

  const onHeaderClick = () => {
    dispatch(changeSelectedContentTitle(activeGroupIdRef.current, null, 'onHeaderClick', null));
  };
  const onClickReload = () => {
    dispatch(changeSelectedContentTitle(activeGroupIdRef.current, selectedContentTitle, 'onClickReload', selectedContentTitleMode));
  };

  return (
    <div className="slip-container">
      <div className="p-3 p-md-4 positin-relative content-list-head">
        <div className="d-flex align-items-center" style={{ borderBottom: "dashed gray 1px" }}>
          <div className="flex-shrink-0 d-block d-md-none me-2">
            <Link
              to="#"
              onClick={onHeaderClick}
              className={classnames("user-chat-remove text-muted font-size-24 p-2", { "user-chat-remove-dark": isDark })}
            >
              <i className="bx bx-chevron-left align-middle"></i>
            </Link>
          </div>
          <div className="flex-grow-1 overflow-hidden">
            <div className="d-flex align-items-center">
              <div className={classnames("flex-shrink-0", "chat-user-img", "align-self-center", "me-3", "ms-0")}>
                <i className={contentTitleSel?.titlePictureUrl} style={{ fontSize: '32pt' }}></i>
              </div>
              <div className="flex-grow-1 overflow-hidden">
                <h6 className="text-truncate mb-0 font-size-18">
                  <Link to="#" className="user-profile-show text-reset" onClick={(e) => e.preventDefault()}>
                    {contentTitleSel?.titleName}
                  </Link>
                  <>
                    &nbsp;
                    {selectedContentTitleLoading && <LoadingIconWithText loadingText={""} />}
                    {!selectedContentTitleLoading && <i className="fas fa-redo hand" onClick={onClickReload}></i>}
                  </>
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ContentUploadSlipCore allowEdit={true} />
    </div>
  );
};

export default ContentUploadSlip;
